import { render, staticRenderFns } from "./EmpTraining.vue?vue&type=template&id=6bf60a6c&scoped=true"
import script from "./EmpTraining.vue?vue&type=script&lang=js"
export * from "./EmpTraining.vue?vue&type=script&lang=js"
import style0 from "./EmpTraining.vue?vue&type=style&index=0&id=6bf60a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf60a6c",
  null
  
)

export default component.exports